module.exports = __webpack_public_path__ + "img/chevron-down.5b160e45.svg";